const applicationTableColumnsTypes = {
  STRING: "string",
  DATE: "date",
  YESNO: "yesNo",
  MULTIPLE_VALUES: "MULTIPLE_VALUES",
  MULTIPLE_MOBILE_VALUE: "MULTIPLE_MOBILE_VALUE",
  CUSTOM: "CUSTOM",
};

export default applicationTableColumnsTypes;
